import fields from './fields';
import validations from './validations';

export default {
  ...fields,
  ...validations,
  sender_name: 'Göndərənin adı',
  sender_wallet: 'Göndərənin pul kisəsi',
  last_n_digits: 'Tranzaksiya referansı',
  invoice_flow__multi_time_remainin: 'Qalan vaxt',
  invoice_flow__multi_or: 'VƏ YA',
  invoice_flow__multi_open_app: 'Tətbiqdə aç',
  invoice_flow__multi_return_button: 'Sayta qayıt',
  invoice_flow__card_transfer_button: 'Təsdiq et',
  invoice_flow__multi_upi_qr_step_1: 'QR kodunu skan edin və ya kopyalayın',
  invoice_flow__multi_upi_qr_step_2: 'Ödəniş edin',
  invoice_flow__multi_step_3:
    'Ödənişi təsdiqləmək üçün <b>{attributes}</b> göstərin və "Təsdiq et" düyməsini basın',
  invoice_flow__multi_upi_qr_mob_step_1: 'QR kodunu skan edin və ya "Tətbiqdə aç" düyməsini basın',
  invoice_flow__multi_bank_transfer_step_1: 'Rekvizitləri kopyalayın',
  invoice_flow__multi_bank_transfer_step_2: 'Ödəniş edin',
  invoice_flow__card_transfer_step_1: 'Rekvizitləri kopyalayın',
  invoice_flow__card_transfer_step_2:
    'Göstərilən məbləği köçürün (öz bankçılığınızdan istifadə edin, özünəxidmət terminalı və ya ən yaxın bank şöbəsinə müraciət edin)',
  invoice_flow__card_transfer_step_3: 'Təsdiq üçün məlumatları göstərin: <b>{attributes}</b>',
  invoice_flow__card_transfer_step_4:
    'Köçürmə müvəffəqiyyətlə başa çatdıqdan sonra <b>"Təsdiq et"</b> düyməsini basın',
};
